module.exports = __webpack_public_path__ + "static/media/dollor.c2df215a.svg";